<button
  id="verbal-hints-button"
  class="verbal-hints-button"
  type="button"
  (click)="onClick()"
  [attr.data-testid]="testId"
  htcAudioClick
  [audioType]="clickType"
  [descriptor]="clickDescriptor">
  <div class="button-circle-thumb">
    <div class="button-circle-thumb-shadow"></div>
    <div class="button-circle-thumb-circle"></div>
    <img class="button-circle-thumb-icon" [src]="path + icon" />
  </div>
</button>
